module.exports = __webpack_public_path__ + "static/img/cont3103.d8c66d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont3103.jpg
// module id = VgWu
// module chunks = 0